import { bound } from "ecce-react";


export class Debouncer {
	#duration: number;
	#timeout: ReturnType<typeof setTimeout> | null = null;

	constructor(duration = 250) {
		this.#duration = duration;
	}

	@bound()
	execute(fn: VoidFunction): void {
		this.dispose();
		this.#timeout = setTimeout(fn, this.#duration);
	}

	@bound()
	dispose(): void {
		if(this.#timeout) {
			clearTimeout(this.#timeout);
			this.#timeout = null;
		}
	}

	set duration(nextDuration: number) {
		this.#duration = nextDuration;
	}
}
